
import React, { useContext, useState } from "react"

import { useMutation } from "@tanstack/react-query";

import { matchPath, Route, Routes, useNavigate } from "react-router-dom";
import { Empty, notification, Divider, Skeleton } from "antd";

import { useRelativePath } from "../../Hooks/useNextRelativePath";
import { useWatchParameterOnRoutes } from "../../Hooks/useGetParameterOnRoutes";

import { Permissoes } from "../../Constants/Permissoes";
import { PropriedadesDeNotificacao } from "../../Utils/Notificacoes";
import { useRedirection } from "../../Hooks/useRedirection";
import { SessaoContext } from "../../Contexts/SessaoContext";
import { TypeResponsavel } from "../../Models/Domain/Pessoa/Responsavel";
import { ResponsavelService } from "../../Services/Domain/Pessoa/ResponsavelService";
import { CadastroDeResponsavel } from "../Viagem/Cadastros/Viagem/Componentes/CadastroDeResponsavel";
import { ListagemDeResponsaveis } from "./Listagem/Responsavel.listagem";

const Responsavel: React.FC<{}> = (props) => {
    const [responsavelEmAlteracao, setResponsavelEmAlteracao] = useState<TypeResponsavel | undefined>(undefined);
    const permissoes = useContext(SessaoContext)?.sessao?.usuario?.permissoes.map((p) => p.nome);

    const navigate = useNavigate();
    const [raiz, subrota] = useRelativePath();

    const rotaDeEdicao = matchPath({ path: "/editar" }, subrota);
    const rotaDeVisualizacao = matchPath({ path: "/detalhes" }, subrota);

    const obterResponsavel = useMutation({
        mutationFn: (id: number) => new ResponsavelService().listar({codigo: id}),
        gcTime: 0,
        onSuccess: (resposta) => {
            const resultados = resposta.data;
            if (resultados.length == 0) {
                notification.open({
                    ...PropriedadesDeNotificacao.Erro("Nenhum registro foi encontrado para o identificador informado")
                })
                navigate(raiz)
            } else {
                setResponsavelEmAlteracao(resposta.data.at(0))
            }
        }
    })

    useRedirection([Permissoes.ListarResponsaveis, Permissoes.CriarResponsavel, Permissoes.AtualizarResponsavel, Permissoes.AtivarResponsavel, Permissoes.DesativarResponsavel])
    useWatchParameterOnRoutes({
        appliablePaths: [rotaDeEdicao, rotaDeVisualizacao], paramToWatch: "id", filters: [(p) => isNaN(Number(p))],
        onNotAccepted() { navigate(raiz) },
        onExists(param) { obterResponsavel.mutate(Number(param)); },
    })

    return (
        <>
            <h2 style={{ marginTop: 0 }}>
                {
                    rotaDeVisualizacao ? "Detalhes do Responsavel" : rotaDeEdicao ? "Edição do Responsavel" : "Cadastro do Responsavel"
                }
            </h2>

            <Divider />

            <Routes>
                {
                    permissoes?.includes(Permissoes.ListarResponsaveis) &&
                    <Route path="*" index element={
                        <ListagemDeResponsaveis
                            hrefDoBotaoAdicionar={raiz + "/cadastro"}
                            hrefDoBotaoEditar={(item) => {
                                if (item.codigo) {
                                    return raiz + `/editar?id=${item.codigo}`
                                }
                            }}

                            aoEditar={(aluno) => {
                                setResponsavelEmAlteracao(aluno)
                            }}
                        />
                    } />
                }

                {
                    permissoes?.includes(Permissoes.CriarResponsavel) &&
                    <Route path="/cadastro" element={
                        <CadastroDeResponsavel privilegio="administrador"
                            aoCancelar={() => navigate(raiz)}
                            depoisDeFinalizar={() => navigate(raiz)}
                        />
                    } />
                }

                {
                    permissoes?.includes(Permissoes.AtualizarResponsavel) &&
                    <Route path="/editar" element={
                        responsavelEmAlteracao == undefined ? <Skeleton active /> :
                        <CadastroDeResponsavel privilegio="administrador"
                            responsavelEmAlteracao={responsavelEmAlteracao}
                            aoCancelar={() => navigate(raiz)}
                            depoisDeFinalizar={() => navigate(raiz)}
                        />
                    } />
                }
            </Routes>
        </>
    );
}

export default Responsavel;